<div class="form-wrapper">
  <h2 class="form-title">{{ 'login-page.forgot.title' | translate }}</h2>
  <p class="form-subtitle">
    {{ 'login-page.forgot.subtitle' | translate }}
  </p>


  @if (sendSuccess) {
    <div class="success-message">
      <p>{{ 'login-page.forgot.success-message' | translate }}</p>
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

    <div class="field-group">
      <label class="field-label">{{ 'forgot.title-mail' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="seu@email.com"
          autocomplete="email"
        />
        @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-required' | translate }}</mat-error>
        } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-error' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <button
      mat-flat-button
      type="submit"
      class="submit-btn full-width"
      [disabled]="isLoading || sendSuccess"
    >
      @if (isLoading) {
        <mat-spinner diameter="20" />
      } @else {
        {{ 'login-page.forgot.submit' | translate }}
      }
    </button>

  </form>

  <div class="card-footer">
    <p class="footer-link-text">
      {{ 'login-page.forgot.remembered' | translate }}
      <button type="button" class="link-btn" (click)="changeView.emit('login')">
        {{ 'login-page.forgot.back-login' | translate }}
      </button>
    </p>
  </div>
</div>
